const initialState = {
  probeTypes: JSON.parse(localStorage.getItem('redux_sync_ProbeTypes')) || [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {

  let payloadData

  switch (action.type) {
    case "PROBE_TYPES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case "PROBE_TYPES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "PROBE_TYPES_FETCH_FULFILLED":
      payloadData = action.payload.data
      localStorage.setItem('redux_sync_ProbeTypes',JSON.stringify(payloadData))
      return {
        ...state,
        fetching: false,
        fetched: true,
        probeTypes: payloadData,
        errors: null,
      }
    case  'USER_SIGN_OUT_PENDING':
      localStorage.removeItem('redux_sync_ProbeTypes')
      return {
        ...initialState,
        probeTypes: [],
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState,
        probeTypes: [],
      }
    default:
      return state
  }

}



// WEBPACK FOOTER //
// ./src/reducers/probeTypesReducer.js